<template>
  <div v-if="notifications.length" v-for="not in notifications" :class="getClass(not.status)" role="alert">
    <h4 class="alert-heading">{{ not.title }}</h4>
    <p>{{ not.text }}</p>
    <hr>
    <p class="mb-0">{{ formatLocal(not.createdAt) }}</p>
    <button @click="onDelete(not.id)" type="button" class="btn-close"></button>
  </div>
  <p v-else>
    Нет уведомлений
  </p>
</template>

<script setup>
import { useNotifications } from '@/features/notifications/composables/useNotifications';
import {onMounted} from "vue";
import { formatLocal } from '@/api/helpers';
const {
  page,
  size,
  load,
  markRead,
  deleteNotificationById,
  totalElements,
  notifications
} = useNotifications();

page.value = 1;
size.value = 4;

function getClass(status) {
  const map = {
    NEW: "alert alert-info  alert-dismissible fade show"
  };
  return map[status] ?? "alert alert-light border-light alert-dismissible fade show";
}

async function onDelete(id) {
  await deleteNotificationById(id);
  load(1, 1000);
}

onMounted(async () => {
  await load(1, 1000);
  markRead();
});
</script>

<style scoped>

</style>